import { omit } from 'lodash-es';
import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';
import {
  ALINEA_CALIBRATION_MAX_DOWNLOAD_ROWS,
  ALINEA_CALIBRATION_METRICS,
} from '@intelligence/v3/pages/TopCharts/PCConsoleGames/AlineaAnalyticsCalibration/constants';

const DOWNLOAD_CONFIG_KEY = 'alineaAnalyticsCalibrationPCConsoleTopCharts';
const DEFAULT_METRICS = ALINEA_CALIBRATION_METRICS.map((item) => {
  return item.value;
});

const getFileName = (params?: IRecord | null): string => {
  if (params?.new_style_donwload_file_name) {
    return params.new_style_donwload_file_name;
  }

  const startDate = params?.start_date || '';
  const endDate = params?.end_date || '';

  return `Top Charts_PC&Console Games_Alinea_Analytics_True Data_${startDate}_${endDate}`;
};

const getDownloadApiParams = (params?: IRecord | null): IRecord => {
  if (!params) {
    return {};
  }

  const hasTopValue = params?.top?.size !== undefined || (params?.top !== undefined && typeof params.top !== 'object');
  const hasSelectTop = params?.select_top !== undefined || hasTopValue;
  const selectTopValue = params?.top?.size ?? params?.top ?? params?.select_top ?? 10;
  const selectTop = Number(selectTopValue);
  const nextParams: IRecord = {
    ...omit(params, [
      'data_sources',
      'download_metrics',
      'file_name',
      'file_format',
      'new_style_donwload_file_name',
      'regionOptions',
      'regionsCountries',
      'genreOptionsMap',
      'select_top',
      'top',
      'granularity',
      'markets',
    ]),
    b_alinea_calibration: 1,
    entity_type: 'combine',
    region_type: 'market',
    order_metric: params?.order_metric || 'date',
    order: params?.order || 'desc',
    page: 1,
    page_size: 100,
    genre_show: params?.genre_show ? 1 : 0,
    release_date_show: params?.release_date_show ? 1 : 0,
    company_show: params?.company_show ? 1 : 0,
    metrics: params?.metrics || DEFAULT_METRICS,
    use_sse_page: {
      max_size: ALINEA_CALIBRATION_MAX_DOWNLOAD_ROWS,
    },
  };

  if (hasSelectTop) {
    nextParams.top = {
      size: selectTop,
    };
  }

  return nextParams;
};

export default (params?: IRecord | null) => {
  const downloadApiParams = getDownloadApiParams(params);

  return {
    ...commonSetting,
    downloadMode: 'commonConf',
    downloadConfigKey: DOWNLOAD_CONFIG_KEY,
    downloadFetchApi: '/api/v1/intelligence_pc/getAlineaCalibrationDetailedListPlus',
    downloadApiParams,
    isUsingNewMethod: false,
    fetchOnlyOnce: false,
    dataKey: undefined,
    $$fileName: getFileName(params),
  };
};
